var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label"},[(_vm.value)?_c('p',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.value),expression:"value"}],style:({ color: _vm.labelColor })}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }